// Base URL of the RedstoneHR API, including the version, e.g.
// https://api.redstonehr.com/v1. Baked in at build time by CRA.
export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4000/v1"
).replace(/\/+$/, "");

// Every request is scoped to the portal's company. There is deliberately no
// unscoped endpoint: those listed every tenant's jobs.
export const apiEndpoints = (slug: string) => {
  const base = `${API_BASE_URL}/public/${encodeURIComponent(slug)}`;
  return {
    company: `${base}/company`,
    jobs: `${base}/jobs`,
    job: (id: string) => `${base}/jobs/${encodeURIComponent(id)}`,
    application: (id: string) =>
      `${base}/application/${encodeURIComponent(id)}`,
  };
};

export default API_BASE_URL;
